import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

$(window).on("load", function () {

  var secCount = $('.js-sec-count').length +1;
  let sectionItem
  let navItem

  // for (let i = 1; i < 6; i++) {
  for (let i = 1; i < secCount; i++) {
    navItem = '.js-current-nav' + i
    sectionItem = '.js-current-sec' + i
    console.log(secCount)
    ScrollTrigger.create({
      trigger: sectionItem,
      start: 'top center',
      end: 'bottom center',
      toggleClass: {
        targets: navItem,
        className: 'is-current',
      },
      // once: true,
      // markers: true,
    });
  }

  // TOPページのセクションにスクロールフェードインエフェクト
  if ($('body').hasClass('p-top')) {
    gsap.utils.toArray('section[id^="sec"]').forEach((section) => {
      gsap.fromTo(section, 
        {
          opacity: 0,
          y: 50
        },
        {
          opacity: 1,
          y: 0,
          duration: 0.8,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: section,
            start: 'top 65%',
            end: 'bottom 20%',
            toggleActions: 'play none none reverse',
            // markers: true, // デバッグ用（必要に応じてコメントアウト）
          }
        }
      );
    });

    // sec02-featureListのアイテムを左から順番に下からフェードイン
    const featureListItems = gsap.utils.toArray('.sec02-featureList__item');
    if (featureListItems.length > 0) {
      const featureList = document.querySelector('.sec02-featureList');
      if (featureList) {
        // SP判定（768px以下）
        const isSP = window.matchMedia("(max-width: 768px)").matches;
        const startValue = isSP ? 'top 85%' : 'top 60%';
        
        gsap.fromTo(featureListItems,
          {
            opacity: 0,
            y: 50
          },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: 'power2.out',
            stagger: 0.2, // 左から順番に0.2秒ずつ遅延
            scrollTrigger: {
              trigger: featureList,
              start: startValue,
              end: 'bottom 20%',
              toggleActions: 'play none none reverse',
              // markers: true, // デバッグ用（必要に応じてコメントアウト）
            }
          }
        );
      }
    }
  }
});
